// extracted by mini-css-extract-plugin
export default {"outlet":"blogsListPage_outlet__jjFmw","box":"blogsListPage_box__Kh7fV"};